import { memo, useEffect, useState } from 'react';
import { TextField, Tooltip, type SxProps, type Theme } from '@mui/material';
import { ellipsisTextFieldSx } from './bankStatementImportUiUtils';

type DraftTextFieldProps = {
  label: string;
  initialValue: string;
  disabled: boolean;
  type?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>;
  onCommit: (value: string) => void;
};

export const DraftTextField = memo(
  ({
    label,
    initialValue,
    disabled,
    type,
    required = false,
    error = false,
    helperText = ' ',
    sx,
    onCommit,
  }: DraftTextFieldProps) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    return (
      <Tooltip title={value || 'Unresolved'} placement="top-start">
        <TextField
          label={label}
          size="small"
          type={type}
          required={required}
          error={error}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onBlur={() => onCommit(value)}
          disabled={disabled}
          helperText={helperText}
          inputProps={type === 'number' ? { step: 'any' } : undefined}
          sx={sx ?? ellipsisTextFieldSx}
        />
      </Tooltip>
    );
  }
);
